import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_user_reconfirm.routes';
import UserPasswordService from '../../../components/api/user_password/user_password.service';

export class OemUserReconfirmController {
  /*@ngInject*/
  constructor($state, $mdDialog, UserPasswordService) {
    this.UserPasswordService = UserPasswordService;
    this.$mdDialog = $mdDialog;
    this.$state = $state;

    this.email = '';
    this.dialogs = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose:true,
        title: '以下のメールアドレスに確認用メールを送信しますか？',
        ok: '送信する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose:true,
        title: '送信が完了しました。',
        content: '送信されたメールをご確認下さい。',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose:true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  $onInit() {}

  showConfirm(ev) {
    this.dialogs.confirm.content(this.email);
    this.$mdDialog.show(this.dialogs.confirm.targetEvent(ev)).then(() => {
      this.UserPasswordService.oem_api.create(
        { email: this.email },
        res => {
          this.$mdDialog.show(this.dialogs.success).finally(() => { this.$state.go('oem_login') });
        },
        err => {
          if(err.status === 404) {
            this.dialogs.error.content('指定したメールアドレスのユーザーが存在しませんでした。');
          }
          this.$mdDialog.show(this.dialogs.error);
        }
      )
    });
  }
}

export default angular.module('leptonApp.oemUserReconfirm', [uiRouter, UserPasswordService])
  .config(routing)
  .component('oemUserReconfirm', {
    template: require('./oem_user_reconfirm.html'),
    controller: OemUserReconfirmController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user_reconfirm/oem_user_reconfirm.component.js